import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";
import useAuthStore from "./useAuthStore";
import Base64e from "../components/encodedecode/encode";

interface MatchesState {
  rows: any[];
  total: number;
  totalPages: number;
  currentPage: number;
  loading: boolean;
  getMatches: (page: number) => Promise<void>;
  deleteMatch: (matchId: number) => Promise<void>;
}

export const useMatchesStore = create<MatchesState>((set, get) => ({
  rows: [],
  total: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,

  getMatches: async (page) => {
    set({ loading: true });

    try {
      const authStore = useAuthStore.getState();
      const user = authStore.user;

      if (!user) {
        set({ loading: false });
        console.error("User not authenticated.");
        return;
      }

      const requestData = {
        id: Base64e.encode(user.id + ""),
        page: page,
        limit: 10,
      };

      const response = await axiosInstance.post("getUserMatches", requestData);

      if (response.status === 200) {
        set({
          rows: response.data.rows,
          total: response.data.count,
          totalPages: Math.ceil(response.data.count / 10),
          currentPage: page,
          loading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching matches:", error);
      set({ loading: false });
    }
  },

  deleteMatch: async (matchId) => {
    try {
      const data = { matchId };
      await axiosInstance.post("deleteMatch", data);

      // Refresh matches after deletion
      get().getMatches(0);

      console.log(`Match ${matchId} deleted successfully.`);
    } catch (error) {
      console.error("Error deleting match:", error);
    }
  },
}));
